import React from "react";
import { StarIcon } from "lucide-react";
import { Section, SectionHeading } from "./Section";
import { testimonials } from "../data/testimonials";
export function TestimonialsSection() {
  return <Section tone="cream" labelledBy="testimonials-title" cta="I want to study like these surgeons" data-id="element-305" data-mp="1n0tyt76ofxev">
      <SectionHeading id="testimonials-title" eyebrow="From colleagues using the Blueprint" title="What surgeons say about their study sessions" data-id="element-306" data-mp="1r0ud8rts08lx" />

      <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-307" data-mp="1i0o39fxadqri">
        {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl border border-line bg-white p-6 sm:p-7" data-id="element-308" data-mp="1416bcrop1xdx">
            <div className="flex gap-0.5 text-gold" aria-label="5 out of 5 stars" data-id="element-309" data-mp="182i4v8aov2re">
              {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-current" aria-hidden="true" data-id="element-310" data-mp="2yfpcaptl7stu" data-mpi={i} />)}
            </div>
            <blockquote className="mt-4 flex-1 font-serif text-lg leading-relaxed text-ink" data-id="element-311" data-mp="32eonut9tqnu9">“{t.quote}”</blockquote>
            <figcaption className="mt-6 flex items-center gap-3 border-t border-line pt-5" data-id="element-312" data-mp="2q2hll0fnbxm7">
              <img src={t.photo} alt={t.name} className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-gold/50" loading="lazy" data-id="element-313" data-mp="2q0n98aifxdtq" />
              <div data-id="element-314" data-mp="2zs15m9f3hxin">
                <p className="font-bold text-ink" data-id="element-315" data-mp="2ztm2w6ssnuk7">{t.name}</p>
                <p className="text-sm text-muted" data-id="element-316" data-mp="2c26srrus08ye">{t.role}</p>
              </div>
            </figcaption>
          </figure>)}
      </div>
    </Section>;
}